import { confirm } from '../../../components/notify';
import { settings } from '../config';
import jQuery from 'jquery';

const stopAll = 'stopall';

jQuery('.clockout.has-active-operations').click(function () {
	let btn = jQuery(this);
	if (btn.val() === stopAll) {
		return true;
	}

	confirm(settings.strings.stopAllActiveOperations)
		.then(result => {
			if (result) {
				btn.val(stopAll);
				btn.click();
			}
		});

	return false;
});
